import * as yup from 'yup';

export const getConsultationQuestionSchema = yup.object().shape({
  question: yup.string().min(1, 'Veuillez écrire une réponse').required(''),
});
